import KonditionenItem from "../type/konditionen-item";

export default class KonditionenStorage {

  constructor() {
    this.defaultWerte = [];
    this.defaultBetrag = null;
    this.defaultItem = {};
    this.timestamp = null;
    this.current = [];
    this.stufen = [];
    this.stufenUpdated = null;
    this.konditionenAbsolut = [];
    this.konditionenAbsolutUpdated = null;
    this.konditionenAbsolutModifiedBy = null;
    this.stufenModifiedBy = null;
    this.listKeys = {
      headers: [],
      editierbar: [],
      konditionen: [],
      preis: [],
      kurs: []
    };
    this._failed = false;
    this.DEFAULT_KENNZIFFER = -1;
    this.mapListe = this.mapListe.bind(this);
    this.mapStufen = this.mapStufen.bind(this);
  }

  failed(error) {
    this._failed = !!error;
    this.error = error;
  }

  failedStufen(error) {
    console.log("Stufen", error);
  }

  mapListe(item, row) {
    const cItem = this.current.find(c => Number(c.kennziffer) === Number(item.kennziffer)) || {};
    const listItem = {
      kennziffer: item.kennziffer || null,
      bezeichnung: item.bezeichnung ? String(item.bezeichnung) : cItem.bezeichnung || 'keine Bezeichnung',
      mwst: item.mwst,
      konditionen: this.listKeys.konditionen.map((k, idx) => {
        // wenn Mitarbeiterkonditionen nicht vorhanden sind, setze normale Kondition
        if (this.listKeys.isMaKond[idx] && k.match(/MaBuy/) && isNaN(item[k])) {
          const std = k.replace(/MaBuy/, "BpBuy");
          return item[std];
        }
        return item[k];
      }),
      preis: this.listKeys.preis.map((p, idx) => {
        // wenn Mitarbeiterkonditionen nicht vorhanden sind, setze normale Kondition
        if (this.listKeys.isMaKond[idx] && p.match(/MaBuy/) && isNaN(item[p])) {
          const std = p.replace(/MaBuy/, "BpBuy");
          return item[std];
        }
        return item[p];
      }),
      kurs: this.listKeys.kurs.map((p, idx) => {
        // wenn Mitarbeiterkonditionen nicht vorhanden sind, setze normale Kondition
        if (this.listKeys.isMaKond[idx] && p.match(/MaBuy/) && isNaN(item[p])) {
          const std = p.replace(/MaBuy/, "BpBuy");
          return item[std];
        }
        return item[p];
      }),
      /* ignore EditierbarKZ
      editierbar: this.listKeys.editierbar.map(e => {
        return item[e];
      }),
      */
      editierbar: this.listKeys.editierbar.map(e => "J"),
      changed: this.listKeys.changed.map(k => {
        return !!item[k];
      }),
      defaultWerte: this.defaultWerte,
    };
    return KonditionenItem.create(listItem, this.listKeys, row);
  }

  mapStufen(item, row) {
    const stufenItem = {
      kennziffer: typeof item.stufenWert === "undefined" ? this.DEFAULT_KENNZIFFER : row,
      konditionen: this.listKeys.konditionen.map(k => {
        // wenn Mitarbeiterkonditionen nicht vorhanden sind, setze normale Kondition
        if (k.isMaKond && isNaN(item[k])) {
          const std = k.replace(/MaBuy/, "BpBuy");
          return item[std];
        }
        return item[k];
      }),
      stufenWert: Number(item.stufenWert) || 0,
      editierbar: this.listKeys.editierbar.map(e => "J")
    };
    return KonditionenItem.create(stufenItem, this.listKeys, row);
  }

  mapKonditionenAbsolut(item, row) {
    console.log("DEBUG: mapKonditionenAbsolut input item:", item);
    const konditionenAbsolutItem = {
      row: row,
      kennziffer: item.kennziffer || this.DEFAULT_KENNZIFFER,
      isMaKond: this.isMaKond,
      konditionenWert: item.position,
      konditionen: this.listKeys.konditionen.map((field, col) => {
        let value;
        if (field === 'emBpBuyKondition') value = item.bpVerkauf;
        if (field === 'emMaBuyKondition') value = item.maKondition;
        if (field === 'emWlBuyKondition') value = item.kuVerkauf;
        return { row, col, field, value: value, label: this.listKeys.headers[col], isMaKond: this.listKeys.isMaKond[col] };
      })
    };
    console.log("DEBUG: mapKonditionenAbsolut output konditionenAbsolutItem:", konditionenAbsolutItem);
    return KonditionenItem.create(konditionenAbsolutItem, this.listKeys, row);
  }

  setListKeys(listKeys) {
    if (this.listKeys && !listKeys) return;
    this.listKeys = {
      headers: [],
      preisHeaders: [],
      editierbar: [],
      konditionen: [],
      changed: [],
      preis: [],
      kurs: [],
      isMaKond: [],
    };
    if (!listKeys) return;
    if (Array.isArray(listKeys.headers)) this.listKeys.headers = listKeys.headers.map(h => String(h));
    if (Array.isArray(listKeys.preisHeaders)) this.listKeys.preisHeaders = listKeys.preisHeaders.map(h => String(h));
    if (Array.isArray(listKeys.editierbar)) this.listKeys.editierbar = listKeys.editierbar.map(e => String(e));
    if (Array.isArray(listKeys.konditionen)) this.listKeys.konditionen = listKeys.konditionen.map(k => String(k));
    if (Array.isArray(listKeys.changed)) this.listKeys.changed = listKeys.changed.map(k => String(k));
    if (Array.isArray(listKeys.preis)) this.listKeys.preis = listKeys.preis.map(p => String(p));
    if (Array.isArray(listKeys.kurs)) this.listKeys.kurs = listKeys.kurs.map(p => String(p));
    if (Array.isArray(listKeys.isMaKond)) this.listKeys.isMaKond = listKeys.isMaKond.map(b => !!b);
  }

  setAll(liste, defaultWerte, listKeys, defaultBetraege) {
    const all = liste || [];
    if (defaultWerte) {
      this.defaultWerte = Array.isArray(defaultWerte)
        ? defaultWerte.map(d => {
          return !isNaN(d) ? Number(d) : 0;
        })
        : [];
    }
    const defaultItem = {
      kennziffer: this.DEFAULT_KENNZIFFER,
      bezeichnung: "Prozent (wird in Endkundenkurs mit eingerechnet)",
      editierbar: this.listKeys.editierbar.map(e => {
        return false;
      }),
      konditionen: this.defaultWerte,
      originalWerte: this.defaultWerte,
      defaultWerte: this.defaultWerte
    };
    this.defaultItem = KonditionenItem.create(defaultItem, listKeys);
    defaultBetraege = Array.isArray(defaultBetraege)
      ? defaultBetraege.map(d => {
        return !isNaN(d) ? Number(d) : 0;
      })
      : [];
    const defaultBetrag = {
      kennziffer: this.DEFAULT_KENNZIFFER,
      bezeichnung: "Euro (pro Warenkorbposition)",
      editierbar: this.listKeys.editierbar.map(e => {
        return false;
      }),
      konditionen: defaultBetraege,
      originalWerte: defaultBetraege,
      defaultWerte: defaultBetraege,
      einheit: defaultBetraege.map(() => "€")
    };
    this.defaultBetrag = KonditionenItem.create(defaultBetrag, listKeys);
    this.setListKeys(listKeys);
    this.current = all.map(this.mapListe).filter(i => !!i);
    if (!this.stufen.find(i => i.kennziffer === this.DEFAULT_KENNZIFFER)) {
      const defaultItem = this.getNewStufe(this.stufen.length);
      this.stufen.push(defaultItem);
    }
  }

  setKondition(item) {
    if (!item) return;
    const changedItem = this.current.find(i => Number(i.kennziffer) === Number(item.kennziffer));
    if (changedItem) {
      this.listKeys.konditionen.forEach((key, col) => {
        if (item[key]) {
          changedItem.setKondition(item[key], col);
        }
      });
    }
  }

  setStufen(stufenKonditionen, updated, modifiedBy) {
    let stufen = (stufenKonditionen || []);
    stufen.sort((a, b) => {
      if (isNaN(a.stufenWert)) return -1;
      if (isNaN(b.stufenWert)) return 1;
      return a.stufenWert < b.stufenWert ? -1 : 1;
    });
    this.stufen = stufen.map(this.mapStufen).filter(i => !!i);
    this.stufenUpdated = new Date(updated);
    this.stufenModifiedBy = modifiedBy;
    if (!this.stufen.find(i => i.kennziffer === this.DEFAULT_KENNZIFFER)) {
      const defaultItem = this.getNewStufe(0);
      this.stufen.unshift(defaultItem);
      this.stufen.forEach((item, idx) => {
        if (typeof item.setRow === "function") item.setRow(idx);
      });
    }
  }

  setKonditionenAbsolut(konditionenAbsolut, updated, modifiedBy) {
    console.log("DEBUG: setKonditionenAbsolut received:", { konditionenAbsolut, updated, modifiedBy });
    this.konditionenAbsolut.push(konditionenAbsolut);
    this.konditionenAbsolutUpdated = new Date(updated);
    this.konditionenAbsolutModifiedBy = modifiedBy;
    if (!this.konditionenAbsolut.find(i => i.kennziffer === this.DEFAULT_KENNZIFFER)) {
      const defaultItem = this.getNewKonditionAbsolut(this.konditionenAbsolut.length);
      this.konditionenAbsolut.push(defaultItem);
    }
  }

  getItems() {
    return this.current;
  }

  getListKeys() {
    return this.listKeys;
  }

  getDefaultWerte() {
    if (!this.defaultBetrag) {
      return { defaultWerte: this.defaultItem };
    }
    return { defaultWerte: this.defaultItem, defaultBetraege: this.defaultBetrag };
  }

  getNewStufe(row) {
    const listKeys = this.getListKeys();
    const defaultWerte = this.defaultItem;
    const editierbar = defaultWerte.konditionen.map(() => "J");
    return KonditionenItem.create({
      ...defaultWerte,
      kennziffer: this.DEFAULT_KENNZIFFER,
      editierbar,
      konditionen: defaultWerte.konditionen.map(d => d.value),
      defaultWerte: defaultWerte.konditionen.map(d => d.value),
      row: row,
      stufenWert: 0,
      bezeichnung: "Defaultstufe",
    }, listKeys, row);
  }

  getNewKonditionAbsolut(row) {
    const listKeys = this.getListKeys();
    const defaultWerte = this.defaultItem;
    const editierbar = defaultWerte.konditionen.map(() => "J");
    return KonditionenItem.create({
      ...defaultWerte,
      kennziffer: this.DEFAULT_KENNZIFFER,
      editierbar,
      konditionen: defaultWerte.konditionen.map(d => d.value),
      defaultWerte: defaultWerte.konditionen.map(d => d.value),
      row: row,
      konditionenWert: 0,
      bezeichnung: "Default Absolut",
    }, listKeys, row);
  }

  getStufen() {
    return this.stufen;
  }

  getStufenLastChange(opts = {}) {
    if (!this.stufenUpdated || isNaN(this.stufenUpdated.valueOf())) return "";
    const locale = opts?.locale || "de-DE";
    return this.stufenUpdated.toLocaleDateString(locale) + " " + this.stufenUpdated.toLocaleTimeString(locale).substring(0, 5);
  }

  getStufenModifiedBy() {
    if (!this.stufenModifiedBy) return "";
    return this.stufenModifiedBy;
  }

  getKonditionenAbsolut() {
    return this.konditionenAbsolut;
  }

  getKonditionenAbsolutLastChange(opts = {}) {
    if (!this.konditionenAbsolutUpdated || isNaN(this.konditionenAbsolutUpdated.valueOf())) return "";
    const locale = opts?.locale || "de-DE";
    return this.konditionenAbsolutUpdated.toLocaleDateString(locale) + " " + this.konditionenAbsolutUpdated.toLocaleTimeString(locale).substring(0, 5);
  }

  getKonditionenAbsolutModifiedBy(opts = {}) {
    if (!this.konditionenAbsolutModifiedBy) return "";
    return this.konditionenAbsolutModifiedBy;
  }

  getQueryItems(query) {
    return (this.current || []).filter(item => {
      return (
        this.isTextMatch(item.bezeichnung, query) || this.isTextMatch(String(item.kennziffer), query)
      );
    });
  }

  isTextMatch(txt, query) {
    return typeof txt !== "string" || txt === ""
      ? false
      : txt.toLowerCase().indexOf(String(query).toLowerCase()) > -1;
  }

  hasNoData() {
    return this.current.length === 0;
  }

  getRequestData() {
    return this.current.map(item => item.toJsonForPayload()).filter(i => !!i);
  }
}
